<script setup lang="ts">
import FooterContacts from '~/components/general/footer/components/footerContacts/FooterContacts.vue';
import CopyrightNotice from '~/components/general/footer/components/copyrightNotice/CopyrightNotice.vue';
</script>

<template>
    <footer class="footer">
        <div class="container footer__inner">
            <FooterContacts class="footer__contacts" />

            <div class="footer__bottom">
                <CopyrightNotice class="footer__copyright" />

                <NuxtLink
                    to="/privacy-policy"
                    class="footer__link"
                >
                    Политика конфиденциальности
                </NuxtLink>
            </div>
        </div>
    </footer>
</template>

<style scoped lang="scss">
@import "styles/footer";
</style>
